import classnames from "classnames";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import tickIcon from "../../assets/icons/tick_greencircle.svg";
import Footer from "../../components/common/Footer/Footer";
import Header from "../../components/common/Header/Header";
import Button from "../../components/core/Button/Button";
import CustomIcon from "../../components/core/CustomIcon/CustomIcon";
import useIsMobile from "../../components/hooks/useIsMobile";
import { APP_PATH } from "../../routes/route";

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile({ breakpoint: 625 });
  const [isFreeTrialThankyouPage, setIsFreeTrialThankyouPage] = useState(false);

  useEffect(() => {
    let showThankYouPage = sessionStorage.getItem("showThankYouPage");
    console.log('showThankYouPage', showThankYouPage);
    if (!showThankYouPage) {
      navigate(-1);
    }
    setIsFreeTrialThankyouPage(sessionStorage.getItem("isFreeTrialThankyouPage"));
    return () => {
      sessionStorage.removeItem("showThankYouPage");
      sessionStorage.removeItem("isFreeTrialThankyouPage")
    };
  }, []);

  return (
    <>
      <Header />
      <div className={classnames("container")}>
        <div className={"thankYouContainer"}>
          <CustomIcon src={tickIcon} iconHeight={40} iconWidth={40} />
          <div className={"heading"}>Thank you!</div>
          <div className={"subHeading"}>Your account is being validated.</div>
          {isFreeTrialThankyouPage && (
            <div className={"content"}>
              Upon approval, you will receive your login credentials via Email
              on your registered email ID.
            </div>
          )}
          <Button
            label="Explore Our platforms"
            clickHandler={() => navigate(`${APP_PATH}/home`)}
            stylebtn={{ margin: "auto", marginTop: "20px" }}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ThankYou;
